import style from './GetInTouch.module.scss'

function GetInTouch() {
  return (
    <div className={style.main}>
      <p>Por sugerencias o dudas: <a href="mailto:biblioteca@mvot.gub.uy">biblioteca@mvot.gub.uy</a></p>
    </div>
  )
}

export {GetInTouch}